// ─── Feature: Custom Mega Menu — updated 2026-04-06 ───────────────────────

// Initialize features that are normally called by HeaderSection
// (requires [data-section-type="header"] — if that's hidden, they never run)
(function () {
  if (typeof theme === 'undefined') return;

  var originalHeader = document.querySelector('[data-section-type="header"]');
  if (originalHeader) return;

  // Announcement bar slider
  if (theme.announcementBar && typeof theme.announcementBar.init === 'function') {
    theme.announcementBar.init();
  }

  // Nav drawer (hamburger mobile menu)
  if (theme.Drawers && document.getElementById('NavDrawer')) {
    theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');
    theme.collapsibles.init(document.getElementById('NavDrawer'));
  }

  // Cart drawer
  if (theme.settings && theme.settings.cartType === 'drawer' && theme.CartDrawer) {
    if (!document.body.classList.contains('template-cart')) {
      new theme.CartDrawer();
    }
  }
})();

(function () {
  var items = document.querySelectorAll('.has-cmm-dropdown');
  var overlay = document.getElementById('cmmDropdownOverlay');

  if (!items.length) return;

  function animateOpen(panel, skipAnimation) {
    var target = panel.scrollHeight;

    if (skipAnimation) {
      panel.style.opacity = '1';
      panel.style.height = target + 'px';
      requestAnimationFrame(function () {
        panel.style.height = 'auto';
      });
      return;
    }

    panel.style.opacity = '0';
    panel.style.height = '0px';

    requestAnimationFrame(function () {
      panel.style.opacity = '1';
      panel.style.height = target + 'px';
    });

    var onEnd = function (e) {
      if (e.propertyName !== 'height') return;
      panel.style.height = 'auto';
      panel.removeEventListener('transitionend', onEnd);
    };
    panel.addEventListener('transitionend', onEnd);
  }

  function animateClose(panel) {
    var current = panel.scrollHeight;
    panel.style.height = current + 'px';
    panel.offsetHeight; // force reflow

    requestAnimationFrame(function () {
      panel.style.opacity = '0';
      panel.style.height = '0px';
    });
  }

  function closeOthers(except) {
    items.forEach(function (item) {
      if (item !== except && item.classList.contains('cmm--open')) {
        var p = item.querySelector('.cmm__panel');
        animateClose(p);
        item.classList.remove('cmm--open');
        item.querySelector('.cmm__trigger').setAttribute('aria-expanded', 'false');
      }
    });
  }

  function closeAll() {
    items.forEach(function (item) {
      if (item.classList.contains('cmm--open')) {
        animateClose(item.querySelector('.cmm__panel'));
        item.classList.remove('cmm--open');
        item.querySelector('.cmm__trigger').setAttribute('aria-expanded', 'false');
      }
    });
    if (overlay) overlay.classList.remove('cmm-overlay--active');
  }

  items.forEach(function (item) {
    var btn = item.querySelector('.cmm__trigger');
    var panel = item.querySelector('.cmm__panel');
    if (!btn || !panel) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var skip = false;
      items.forEach(function (other) {
        if (other !== item && other.classList.contains('cmm--open')) {
          skip = true;
        }
      });

      if (item.classList.contains('cmm--open')) {
        animateClose(panel);
        item.classList.remove('cmm--open');
        btn.setAttribute('aria-expanded', 'false');
        if (overlay) overlay.classList.remove('cmm-overlay--active');
      } else {
        closeOthers(item);
        item.classList.add('cmm--open');
        btn.setAttribute('aria-expanded', 'true');
        if (overlay) overlay.classList.add('cmm-overlay--active');
        animateOpen(panel, skip);
      }
    });
  });

  // Close on click outside or on overlay
  document.addEventListener('click', function (e) {
    var inside = e.target.closest('.has-cmm-dropdown');
    var isOverlay = overlay && e.target === overlay;
    var isLink = e.target.closest('.cmm__panel a');

    if (isOverlay || isLink || !inside) {
      closeAll();
    }
  });
})();


// ─── Feature: Subscription Tier Callout Reposition — 2026-04-21 ─────────────
// Moves the '.subscription-tier-callout' element out of the product form and
// places it directly above the Recharge subscription widget so the 1/2/3+ bag
// savings visually connect to the Subscribe box. Kopia-only.
(function () {
  function reposition() {
    var callout = document.querySelector('.subscription-tier-callout');
    var widget  = document.querySelector('.recharge-subscription-widget');
    if (!callout || !widget) return false;
    if (callout.parentElement === widget.parentElement && callout.nextElementSibling === widget) {
      // already in place
      return true;
    }
    // Insert callout as sibling immediately before the Recharge widget
    widget.parentElement.insertBefore(callout, widget);
    callout.classList.add('sc-repositioned');
    return true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reposition);
  } else {
    reposition();
  }

  // Recharge widget renders async — watch for it and reposition if it appears later or re-renders
  var observer = new MutationObserver(function () {
    reposition();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Safety fallback: try a few times over the next few seconds in case the widget is slow
  var tries = 0;
  var poll = setInterval(function () {
    tries++;
    if (reposition() || tries > 20) clearInterval(poll);
  }, 250);
})();

// ─── Feature: Mega-menu open flag — added 2026-07-29 ──────────────────────────
// Toggle html.cmm-menu-open whenever a mega-menu dropdown is open, so the
// transparent hero header on the intro-preview pages can snap to its solid
// white state (see the matching rules in custom.css). CSS :has() can't do this
// reliably (Chromium won't restyle the :has element's own background on a deep
// descendant class change), so we drive it from a MutationObserver.
(function () {
  var header = document.querySelector('.cmm-header');
  if (!header) return;
  var sync = function () {
    var open = !!header.querySelector('.cmm__item.cmm--open');
    document.documentElement.classList.toggle('cmm-menu-open', open);
  };
  new MutationObserver(sync).observe(header, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
  sync();
})();

// SEO LAB WAVE H / CODEX — 2026-08-16
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const roots = new Set();
  let frame = 0;

  function setExpanded(button, next) {
    button.classList.toggle('is-open', next);
    button.setAttribute('aria-expanded', String(next));
  }

  function wireToggle(button) {
    if (button.dataset.seoHReady === 'true') return;
    button.dataset.seoHReady = 'true';
    button.addEventListener('click', () => {
      setExpanded(button, button.getAttribute('aria-expanded') !== 'true');
    });
    button.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      button.click();
    });
  }

  function typeLine(node) {
    if (node.dataset.typed === 'true') return;
    node.dataset.typed = 'true';
    const value = node.dataset.typewriter || '';
    if (reduceMotion.matches) {
      node.textContent = value;
      return;
    }
    let index = 0;
    const tick = () => {
      node.textContent = value.slice(0, index);
      index += 1;
      if (index <= value.length) window.setTimeout(tick, 34 + (index % 4) * 9);
    };
    tick();
  }

  function observe(root) {
    const cards = [...root.querySelectorAll('[data-wave-h-block]')];
    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      cards.forEach((card) => {
        card.classList.add('is-visible');
        card.querySelectorAll('[data-typewriter]').forEach(typeLine);
      });
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        entry.target.querySelectorAll('[data-typewriter]').forEach(typeLine);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.28, rootMargin: '0px 0px -8% 0px' });
    cards.forEach((card) => observer.observe(card));
  }

  function updateScrollEffects() {
    frame = 0;
    if (reduceMotion.matches) return;
    roots.forEach((root) => {
      root.querySelectorAll('[data-parallax], [data-roast-scrub]').forEach((scene) => {
        const rect = scene.getBoundingClientRect();
        const viewport = window.innerHeight || 1;
        const progress = Math.max(0, Math.min(1, (viewport - rect.top) / (viewport + rect.height)));
        if (scene.hasAttribute('data-parallax')) scene.style.setProperty('--parallax', progress.toFixed(3));
        if (scene.hasAttribute('data-roast-scrub')) scene.style.setProperty('--roast', String(Math.round(progress * 100)));
      });
    });
  }

  function queueScrollEffects() {
    if (frame) return;
    frame = window.requestAnimationFrame(updateScrollEffects);
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-seo-wave-h-codex]').forEach((root) => {
      if (root.dataset.seoHReady === 'true') return;
      root.dataset.seoHReady = 'true';
      roots.add(root);
      root.querySelectorAll('[data-photo-fan], [data-postcard]').forEach(wireToggle);
      observe(root);
    });
    queueScrollEffects();
  }

  window.addEventListener('scroll', queueScrollEffects, { passive: true });
  window.addEventListener('resize', queueScrollEffects, { passive: true });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-seo-wave-h-codex]').forEach((root) => roots.delete(root));
  });
  init();
})();

// ─── ADA fix day 2026-09-13 (WCAG 2.2 A/AA) ────────────────────────────────────────────────────────
(function () {
  // 1. Nothing inside aria-hidden="true" is a keyboard stop (2.4.3 / 4.1.2): inactive carousel slides, the hidden hero
  //    overlay link, the closed photo viewer. Restored the moment the container becomes visible again.
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex="0"]';
  function untab() {
    document.querySelectorAll('[aria-hidden="true"]').forEach(function (h) {
      h.querySelectorAll(FOCUSABLE).forEach(function (el) {
        if (el.getAttribute('tabindex') === '-1') return;
        el.setAttribute('data-ada-tabindex', el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : '');
        el.setAttribute('tabindex', '-1');
      });
    });
    document.querySelectorAll('[data-ada-tabindex]').forEach(function (el) {
      if (el.closest('[aria-hidden="true"]')) return;
      var prev = el.getAttribute('data-ada-tabindex');
      if (prev === '') el.removeAttribute('tabindex'); else el.setAttribute('tabindex', prev);
      el.removeAttribute('data-ada-tabindex');
    });
  }
  var untabTimer;
  function scheduleUntab() { clearTimeout(untabTimer); untabTimer = setTimeout(untab, 60); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', untab); else untab();
  window.addEventListener('load', scheduleUntab);
  new MutationObserver(scheduleUntab).observe(document.documentElement, { attributes: true, attributeFilter: ['aria-hidden'], childList: true, subtree: true });

  // 2. Reduced motion (2.3.3): no autoplaying background video and no rotating announcement for people who asked for less motion.
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  function applyReducedMotion() {
    if (!reduce || !reduce.matches) return;
    document.querySelectorAll('video[autoplay]').forEach(function (v) { try { v.pause(); v.removeAttribute('autoplay'); } catch (e) { /* video not ready */ } });
    if (window.Flickity) {
      document.querySelectorAll('.flickity-enabled').forEach(function (el) {
        var f = window.Flickity.data(el);
        if (f && f.options && f.options.autoPlay) f.stopPlayer();
      });
    }
  }
  applyReducedMotion();
  window.addEventListener('load', function () { setTimeout(applyReducedMotion, 600); });

  // 3. Intro video pause/play button (2.2.2).
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-chir-pause]');
    if (!b) return;
    var wrap = b.closest('.custom-hero-intro-row');
    var v = wrap && wrap.querySelector('video');
    if (!v) return;
    var wasPaused = b.getAttribute('aria-pressed') === 'true';
    if (wasPaused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
    b.setAttribute('aria-pressed', wasPaused ? 'false' : 'true');
    b.setAttribute('aria-label', wasPaused ? 'Pause background video' : 'Play background video');
  });

  // 4. Horizontal scroll regions (review cards on phones) are keyboard reachable only while they actually scroll (2.1.1).
  function scrollRegions() {
    document.querySelectorAll('.reviews-grid').forEach(function (el) {
      if (el.scrollWidth > el.clientWidth + 2) el.setAttribute('tabindex', '0'); else el.removeAttribute('tabindex');
    });
  }
  var srTimer;
  scrollRegions();
  window.addEventListener('load', scrollRegions);
  window.addEventListener('resize', function () { clearTimeout(srTimer); srTimer = setTimeout(scrollRegions, 150); });
})();

// ═══ ADA third pass 2026-09-18 ═══
// 2.1.1 (scanner "tabindex zero"): Flickity gives the rotating announcement messages tabindex="0" although nothing in the
// strip itself is actionable (the pause button is a separate control and links inside stay focusable). Drop it, and keep it
// dropped when the slider re-initialises on a breakpoint change.
(function () {
  var bar = document.getElementById('AnnouncementSlider');
  if (!bar || typeof MutationObserver === 'undefined') return;
  function strip() { if (bar.getAttribute('tabindex') === '0') bar.removeAttribute('tabindex'); }
  strip();
  new MutationObserver(strip).observe(bar, { attributes: true, attributeFilter: ['tabindex'] });
  window.addEventListener('load', strip);
})();

// ADA third pass 2026-09-18 b (axe image-redundant-alt on the cart page): cards that theme.js builds in the browser
// (Recently viewed, predictive search) put the product image and the product title inside ONE link, with the image's
// alt equal to the title, so screen readers hear the name twice. The Liquid product cards already keep the image decorative
// next to the title; this does the same for the JS-built cards, whenever they appear.
(function () {
  if (typeof MutationObserver === 'undefined') return;
  function fix(root) {
    (root.querySelectorAll ? root.querySelectorAll('.grid-product__link img[alt]') : []).forEach(function (img) {
      var link = img.closest('.grid-product__link');
      var title = link && link.querySelector('.grid-product__title');
      if (title && img.getAttribute('alt').trim() === title.textContent.trim()) img.setAttribute('alt', '');
    });
  }
  fix(document);
  new MutationObserver(function (muts) { muts.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) fix(n); }); }); }).observe(document.documentElement, { childList: true, subtree: true });
})();
